import { withPermissionGuard } from '@libs/permission'
import { EditCampaignPage } from './EditCampaignPage'
import { withEditCampaignPage } from './withEditCampaignPage'

const Connected = withPermissionGuard(
  withEditCampaignPage(EditCampaignPage),
  'promotionCampaign',
  'edit'
)

export { Connected as EditCampaignPage }
